import React, { useState } from 'react';
import { Typography, InputNumber } from 'antd';

const { Title } = Typography;

const Minutes = (props) => {
  return (
    <div>
      <Title>Minutes</Title>
      Start at:
      <> </>
      <InputNumber min={0} max={59} value={props.start} size={'large'} onChange={props.onStartChange}/>
      <> </>
      and run every
      <> </>
      <InputNumber min={0} max={59} value={props.freq} size={'large'} onChange={props.onFreqChange} />
      minutes
      <> </>
    </div>
  );
};

export default Minutes;